import CustomStepper from '../../JobApplicationEntity/Stepper';
import {
    Box,
    Card,
    Icon,
    IconButton,
    Typography,
    useAppDispatch,
    useAppSelector,
    useTheme,
} from '../../../base';
import { IJob, IStepData, JobApplicationStatusUpdateValues, JobStatus } from '../../../common';
import { useTranslation } from 'react-i18next';
import { jobsActions, jobsSelectors } from '../../../actions';
import { RoutePaths } from '../../../routes/RoutePaths';
import { useLocation, useNavigate } from 'react-router-dom';

interface Props {
    isEmployerView?: boolean;
    isPreview?: boolean;
}
const JobStepsViewer = ({
    isEmployerView = false,
    isPreview = false,
}: Props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const stepperInfo = useAppSelector(jobsSelectors.getJobStepperInfo);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const steps = useAppSelector(jobsSelectors.getFormattedJobSteps);
    const job: IJob = useAppSelector(jobsSelectors.getActiveJob) || ({} as IJob);

    const onEditClick = () => {
        dispatch(
            jobsActions.setStepperInfo({
                stepperInfo: {
                    ...stepperInfo,
                    activeStepIndex: 2,
                },
            })
        );
        if (!location.pathname.includes(RoutePaths.saveJob)) {
            navigate(`${location.pathname}/save-job${location.search}`);
        }
    };

    return (
        <Card
            sx={{
                paddingTop: theme.spacing(3),
                boxShadow: 'none',
                border: isPreview
                    ? `1px solid ${theme.palette.grey[400]}`
                    : 'none',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 2,
                }}
            >
                <Typography variant="h4" color="black">
                    {t('positionPage.interviewSteps')}
                </Typography>

                <Box display="flex" justifyContent="flex-end">
                    {(isEmployerView || isPreview) && job.status !== JobStatus.Legacy && (
                        <IconButton
                            onClick={onEditClick}
                            sx={{ marginInlineEnd: theme.spacing(-2) }}
                        >
                            <Icon name={'EditIcon'} />
                        </IconButton>
                    )}
                </Box>
            </Box>
            <CustomStepper steps={steps} />
        </Card>
    );
};

export default JobStepsViewer;
